import { TopToolbarStrategy } from '../ports/toolbar-strategy.port';
import { INavLink } from './nav-link.model';

export enum AppSection {
  DASHBOARD = 'dashboard',
  CRM = 'crm',
  OPERATIONS = 'operations',
  INCOME = 'income',
  OUTCOME = 'outcome',
  DCD = 'dcd',
  ADMIN = 'admin',
  CONFIG = 'config',
}

export type SectionRegistry = {
  [key in AppSection]: {
    navLink: INavLink;
    strategy: () => Promise<{ default: new () => TopToolbarStrategy }>;
  };
};
